module.exports = __webpack_public_path__ + "static/media/trustflight-logo-white.c0c73316.svg";